module.exports = __webpack_public_path__ + "assets/img/y4.01e42a16.png";